// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3H8OF","form":"styles_form__ZyuFi"};